/*
  useId.js
*/

// Npm.
import { useRef } from 'react';

// Global count.
let _count = 0;

/**
 * Hook to return a unique ID.
 */
export default function useId() {

  // NOTE: If using react 18, just drop in the react 18 version here.

  const idRef = useRef(null);

  if (idRef.current == null) {
    idRef.current = _count;
    _count += 1;
  }

  return idRef.current;

}
